"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPersistence = void 0;
const local_data_1 = require("../helpers/local-data");
class UserPersistence {
    static get user() {
        var _a, _b;
        return ((_b = (_a = local_data_1.LocalData.readStorage(local_data_1.StorageKeys.userId)) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null);
    }
    static set user(userId) {
        if (userId === null || !userId.length) {
            local_data_1.LocalData.deleteStorage(local_data_1.StorageKeys.userId);
            return;
        }
        local_data_1.LocalData.writeStorage(local_data_1.StorageKeys.userId, { id: userId });
    }
    static clearUser() {
        local_data_1.LocalData.deleteStorage(local_data_1.StorageKeys.userId);
    }
}
exports.UserPersistence = UserPersistence;
